import React, { useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { MainButtonInput } from "../../../mainComponent/mainButtonInput";
import { MainInput } from "../../../mainComponent/mainInput";
import AuthApi from "../../../services/AuthApi";
import { useRecoilState } from "recoil";
import { setDoctorId } from "../../../recoil/atom/setDoctorId";
import Toaster from "../../Toaster";
import { Wrapper } from "../../../mainComponent/Wrapper";
import { MainNav } from "../../../mainComponent/mainNav";

// export default function ForgotDoctorMpin() {
//   const location = useLocation();
//   const { mobile, loginData } = location.state || {};
//   const [isError, setIsError] = useState(false);
//   const [doctorId, setdoctorId] = useRecoilState(setDoctorId);
//   const { forgotMpin } = AuthApi();
//   const navigate = useNavigate();
//   const [data, setData] = useState({
//     password: "",
//     confirmPassword: "",
//   });
//   const handleChange = (event) => {
//     const { name, value } = event.target;
//     setData({ ...data, [name]: value });
//   };
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const password = data.password.trim();
//     const confirmPassword = data.confirmPassword.trim();
//     if (password === "" || confirmPassword === "") {
//       setIsError(true);
//     } else if (password === confirmPassword) {
//       const bodyData = {
//         mobile: mobile,
//         password: password,
//       };
//       forgotMpin(bodyData).then((response) => {
//         const doctorId = response?.data._id;
//         setdoctorId(response?.data._id);
//         setIsError(response?.data.message);
//         if (response?.data?.isLoggedIn === true) {
//           navigate(`/profile/${doctorId}`);
//         } else {
//           setIsError(true);
//         }
//       });
//     } else {
//       setIsError(true);
//     }
//   };

//   return (
//     <main>
//       <div className="bg_color_2">
//         <div className="container margin_60_35">
//           <div id="login-2">
//             <h1>Reset Mpin</h1>
//             <form>
//               <div className=" clearfix">
//                 <div className=" last">
//                   <lable className="mb-2 font_weight">Enter MPIN</lable>
//                   <div className="col-md-12">
//                     <MainInput
//                       type="password"
//                       name="password"
//                       maxLength={6}
//                       value={data.password}
//                       pattern="[+-]?\d+(?:[.,]\d+)?"
//                       onChange={handleChange}
//                       placeholder="New MPIN"
//                       required
//                     ></MainInput>
//                   </div>

//                   <lable className="mb-2 font_weight">Confirm MPIN</lable>
//                   <div className="col-md-12">
//                     <MainInput
//                       type="password"
//                       name="confirmPassword"
//                       value={data.confirmPassword}
//                       maxLength={6}
//                       pattern="[+-]?\d+(?:[.,]\d+)?"
//                       onChange={handleChange}
//                       placeholder="Confirm MPIN"
//                       required
//                     ></MainInput>
//                   </div>
//                   <div className="row float-right toaster">
//                     <Toaster />
//                   </div>
//                   <div className="">
//                     <MainButtonInput onClick={handleSubmit}>
//                       Reset Mpin
//                     </MainButtonInput>
//                   </div>
//                   {isError === true ? (
//                     <div className="validation mb-2 ml-3">
//                       Password is mismatch
//                     </div>
//                   ) : null}
//                 </div>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </main>
//   );
// }
export default function ForgotDoctorMpin() {
  const location = useLocation();
  const { mobile, loginData } = location.state || {};
  const [isError, setIsError] = useState(false);
  const [doctorId, setdoctorId] = useRecoilState(setDoctorId);
  const { forgotMpin } = AuthApi();
  const navigate = useNavigate();

  const [data, setData] = useState({
    password: "",
    confirmPassword: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setData({ ...data, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const password = data.password.trim();
    const confirmPassword = data.confirmPassword.trim();

    if (password === "" || confirmPassword === "") {
      setIsError(true);
    } else if (password === confirmPassword) {
      forgotMpin({ mobile, password }).then((response) => {
        const doctorId = response?.data._id;
        setdoctorId(doctorId);

        if (response?.data?.isLoggedIn === true) {
          navigate(`/profile/${doctorId}`);
        } else {
          setIsError(true);
        }
      });
    } else {
      setIsError(true);
    }
  };

  return (
    <main>
      <div className="bg_color_2">
        <div className="container margin_60_35">
          <div id="login-2">
            <h1>Reset Mpin</h1>

            <form>
              <div className="clearfix">
                <div className="last">
                  <lable className="mb-2 font_weight">Enter MPIN</lable>
                  <div className="col-md-12 mt-2">
                    <MainInput
                      type="password"
                      name="password"
                      maxLength={6}
                      value={data.password}
                      onChange={handleChange}
                      placeholder="New MPIN"
                      required
                    />
                  </div>

                  <lable className="mb-2 font_weight">Confirm MPIN</lable>
                  <div className="col-md-12 mt-2">
                    <MainInput
                      type="password"
                      name="confirmPassword"
                      maxLength={6}
                      value={data.confirmPassword}
                      onChange={handleChange}
                      placeholder="Confirm MPIN"
                      required
                    />
                  </div>

                  <div className="">
                    <MainButtonInput onClick={handleSubmit}>
                      Reset Mpin
                    </MainButtonInput>
                  </div>

                  {isError && (
                    <div className="validation mb-2 ml-3">
                      Password is mismatch
                    </div>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </main>
  );
}
